(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-text-columns"] && !window.DesignMode) return;
  try {
    
  class Circles {
    constructor() {
      this.circles = document.querySelectorAll('circle');
      this.atcButtons = document.querySelectorAll('[data-add-to-cart-button]');
      this.init();
    }

    init() {
      this.circles.forEach((circle) => {
        circle.insertAdjacentHTML(
          'beforeend',
          '<svg width="120" height="56" viewBox="0 0 120 56" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg"><clipPath id="outline"><path d="M 93.705 6.699 C 99.526 7.46 105.346 8.239 111.094 9.298 C 111.285 9.335 111.178 8.912 111.165 8.856 C 110.877 8.026 110.503 7.062 109.777 6.593 C 82.91 2.691 54.83 -2.781 26.976 5.582 C -8.39 16.962 -3.594 44.362 27.453 50.925 C 49.214 55.679 77.155 56.967 99.562 48.791 C 131.762 35.762 116.881 13.011 93.705 6.699 Z M 29.017 48.892 C 17.025 46.41 -4.534 39.075 6.903 22.02 C 6.902 22.03 6.887 22.043 6.88 22.052 C 6.894 22.033 6.904 22.015 6.919 21.997 C 6.919 21.997 6.919 22.002 6.918 22.007 C 18.136 7.818 38.318 4.979 54.022 4.048 C 43.952 5.336 33.099 6.946 24.117 13.113 C 24.019 13.972 24.822 15.47 25.551 15.797 C 50.001 2.122 86.861 2.588 108.596 15.618 C 111.923 18.444 116.251 21.336 116.671 26.291 C 111.108 58.214 50.202 52.807 29.01 48.891 L 29.017 48.892 Z" /></clipPath><path  class="circle-outline" fill="none" stroke="#865A44" stroke-miterlimit="10" stroke-width="4" clip-path="url(#outline)" d="M 24.112 14.886 C 31.8 9.364 45.459 5.9 64.223 5.932 C 81.534 5.962 117.177 8.878 117.56 25.95 C 117.836 38.257 105.282 54.349 61.27 53.252 C 22.34 52.281 4.251 44.007 3.727 29.769 C 3.41 21.128 10.848 13.238 25.169 7.962 C 35.244 4.251 46.245 2.873 55.293 2.218 C 68.874 1.235 93.561 3.449 112.207 7.83" /></svg>'
        );
      });

      this.atcButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          document.querySelector('[data-add-to-cart]').click();
        });
      });
    }
  }
  new Circles();

  } catch(e) { console.error(e); }
})();
})();
